import axios from "axios";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Redirect } from "react-router";
import { Link } from "react-router-dom";
import {
    Dropdown,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Pagination,
    PaginationItem,
    PaginationLink,
} from "reactstrap";
import {
    GET_ALL_PUBLIC_SUBSCRIPTIONS_URL,
    ITEMS_PER_PAGE_LIST,
    LOGIN_ROUTE,
    PUBLIC_MEETING_ROUTE,
} from "../../constants";
import {
    addAllPublicSubscriptions,
    removeAllPublicSubscriptions,
} from "../../redux/publicSubscription/publicSubscriptionActions";
import ProjectNavbar from "../widgets/projectNavbar";
import ProjectTable from "../widgets/projectTable";

const PublicSusbcriptions = () => {
    const jwt = useSelector((state) => state.authReducer.jwt);
    const currentUser = useSelector((state) => state.authReducer.currentUser);

    const publicSubscriptions = useSelector(
        (state) => state.publicSubscriptionReducer.publicSubscriptions
    );
    const dispatch = useDispatch();

    const [perPage, setPerPage] = useState(10);
    const [pageNumber, setPageNumber] = useState(1);
    const [totalItems, setTotalItems] = useState(0);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const toggle = () => setDropdownOpen((prevState) => !prevState);

    async function fetchPublicSubscriptions() {
        const response = await axios(
            GET_ALL_PUBLIC_SUBSCRIPTIONS_URL +
                `?per_page=${perPage}&page=${pageNumber}`,
            {
                headers: { Authorization: `Bearer ${jwt}` },
            }
        );

        let publicSubscriptionsList = [];
        response.data.publicSubscriptions.data.forEach(
            (publicSubscriptions) => {
                publicSubscriptionsList.push(publicSubscriptions);
            }
        );
        setTotalItems(response.data.publicSubscriptions.total);

        dispatch(addAllPublicSubscriptions(publicSubscriptionsList));
    }
    useEffect(() => {
        fetchPublicSubscriptions();
        return () => {
            dispatch(removeAllPublicSubscriptions());
        };
    }, [dispatch, perPage, pageNumber]);

    function handleItemsPerPageChange(e, newPerPage) {
        e.preventDefault();

        setPerPage(newPerPage);
        setPageNumber(1);
    }

    var paginationLinks = [];
    for (var i = 1; i <= Math.ceil(totalItems / perPage); i++) {
        paginationLinks.push(i);
    }

    return (
        <>
            {jwt === null ? (
                // if the user is not logged in then redirect to login
                <Redirect to={LOGIN_ROUTE} />
            ) : (
                <div className="container-lg">
                    <ProjectNavbar />
                    <div className="container-fluid">
                        <div className="page-header">
                            <h1 className="d-inline">Public Subscriptions</h1>
                            <Link
                                to={PUBLIC_MEETING_ROUTE.replace(
                                    ":client_slug",
                                    currentUser.current_client_slug
                                )}
                                className="nounderline btn btn-primary ms-3 float-end"
                            >
                                Go to Public Meetings
                            </Link>
                        </div>
                        <hr />
                        <div className="my-4">
                            Show
                            <Dropdown
                                isOpen={dropdownOpen}
                                toggle={toggle}
                                className="d-inline mx-2"
                            >
                                <DropdownToggle caret>{perPage}</DropdownToggle>
                                <DropdownMenu>
                                    {ITEMS_PER_PAGE_LIST.map((itemPerPage) => {
                                        return (
                                            <DropdownItem
                                                key={itemPerPage}
                                                onClick={(e) =>
                                                    handleItemsPerPageChange(
                                                        e,
                                                        itemPerPage
                                                    )
                                                }
                                            >
                                                {itemPerPage}
                                            </DropdownItem>
                                        );
                                    })}
                                </DropdownMenu>
                            </Dropdown>
                            entries
                        </div>
                        <ProjectTable
                            data={publicSubscriptions}
                            type="PUBLIC SUBSCRIPTIONS"
                        />
                        <Pagination
                            aria-label="Page navigation example"
                            className="justify-content-center"
                        >
                            {paginationLinks.map((paginationLink) => (
                                <PaginationItem
                                    key={paginationLink}
                                    active={pageNumber === paginationLink}
                                >
                                    <PaginationLink
                                        onClick={(e) => {
                                            e.preventDefault();
                                            if (pageNumber !== paginationLink)
                                                setPageNumber(paginationLink);
                                        }}
                                    >
                                        {paginationLink}
                                    </PaginationLink>
                                </PaginationItem>
                            ))}
                        </Pagination>
                    </div>
                </div>
            )}
        </>
    );
};

export default PublicSusbcriptions;
